import type { Dayjs } from 'dayjs'

export const CALENDAR_RANGE_YEARS = 5

export function isCalendarMonthAllowed(month: Dayjs, now: Dayjs): boolean {
  const firstAllowedMonth = now.subtract(CALENDAR_RANGE_YEARS, 'year').startOf('month')
  const lastAllowedMonth = now.add(CALENDAR_RANGE_YEARS, 'year').startOf('month')
  const targetMonth = month.startOf('month')

  return !targetMonth.isBefore(firstAllowedMonth) && !targetMonth.isAfter(lastAllowedMonth)
}

export function isCalendarDateAllowed(at: Dayjs, now: Dayjs): boolean {
  const firstAllowedDate = now.subtract(CALENDAR_RANGE_YEARS, 'year')
  const lastAllowedDate = now.add(CALENDAR_RANGE_YEARS, 'year')

  return !at.isBefore(firstAllowedDate) && !at.isAfter(lastAllowedDate)
}
